import $ from 'jquery';
import {featureFlag} from '../allspice_app/lib/feature-flag.ts';
import {sanitizeRepoName} from './repo-common.ts';

export function initRepoNew() {
  const pageContent = document.querySelector('.page-content.repository.new.repo');
  if (!pageContent) return;

  const form = pageContent.querySelector<HTMLFormElement>('form');
  // AllSpice: the quick-review create template (create-quick.tmpl) doesn't have
  // gitignores, license, or auto_init fields, so all of these may be null.
  // Upstream's repo-new.ts assumes they always exist because upstream only has one
  // create template.
  const inputGitIgnores = form.querySelector<HTMLInputElement>('input[name="gitignores"]');
  const inputLicense = form.querySelector<HTMLInputElement>('input[name="license"]');
  const inputAutoInit = form.querySelector<HTMLInputElement>('input[name="auto_init"]');
  if (inputAutoInit) {
    const updateUiAutoInit = () => {
      inputAutoInit.checked = Boolean(inputGitIgnores?.value || inputLicense?.value);
    };
    inputGitIgnores?.addEventListener('change', updateUiAutoInit);
    inputLicense?.addEventListener('change', updateUiAutoInit);
  }

  allspiceRepoNew();
}

function allspiceRepoNew() {
  const newRepoForm: HTMLFormElement = document.querySelector('.new.repo form');
  newRepoForm.addEventListener('input', () => {
    // once a field has been touched, remove the initial class from the form so that fields are correctly styled
    // normally fomantic would do this for us, but we don't really use its client-side validation (or any, except for here)
    // and it doesn't plug in well to how this is currently built
    newRepoForm.classList.remove('initial');
  }, {once: true});

  // add validation for the repo name field
  const repoNameInput: HTMLInputElement = document.querySelector('.new.repo form input[name=repo_name]');
  repoNameInput.addEventListener('input', () => {
    if (repoNameInput.validity.valueMissing) {
      repoNameInput.setCustomValidity('This field is required.');
    } else if (repoNameInput.validity.patternMismatch) {
      repoNameInput.setCustomValidity(`Repository name should contain only alphanumeric, dash ('-'), underscore ('_') and dot ('.') characters.`);
    } else {
      repoNameInput.setCustomValidity('');
    }
    repoNameInput.reportValidity();
  });

  if (!featureFlag('quickReviewPreview')) {
    const updateHiddenLicense = function () {
      const privateInput = document.querySelector<HTMLInputElement>('input[name=private]');
      if (privateInput?.checked) {
        $('input[name=license]').parent().parent().insertAfter($('#advanced_settings > summary'));
      } else {
        $('input[name=license]').parent().parent().insertBefore('#advanced_settings');
      }
    };

    updateHiddenLicense();

    $('input[name=private]').on('change', updateHiddenLicense);
  }

  // get all org ids from the page
  const orgValueArray = Array.from(document.querySelectorAll('[data-is-org]'), (elem) => elem.getAttribute('data-value'));

  const isOrg = function () {
    const orgId = document.querySelector<HTMLInputElement>('#uid')?.value;

    return orgValueArray.includes(orgId);
  };

  const privateInputElm = document.querySelector('input[name=private]');
  const uidInputElm = document.querySelector('#uid');

  const handleOwnerText = function () {
    const orgName = document.querySelector('#repo_owner_dropdown .truncated-item-name').textContent;
    const ownerSelected = document.querySelector<HTMLInputElement>('#repo_owner_dropdown input')?.value.length > 0;

    if (ownerSelected) {
      const ownerHelperTxtElm = document.querySelector('#owner_helper_text');
      if (isOrg()) {
        ownerHelperTxtElm.textContent = `This repository will be owned by ${orgName}. This is a good option for projects that are ready to be shared with teams in your organization. Ownership can be transferred later within repository settings.`;
      } else {
        ownerHelperTxtElm.textContent = 'This repository will be owned by your personal account. This is a good option for projects that are experimental or not ready to be shared amongst your organization. Ownership can be transferred later within repository settings.';
      }
    }
  };
  repoNameInput.addEventListener('change', () => {
    repoNameInput.value = sanitizeRepoName(repoNameInput.value);
  });

  const handleVisibilityText = function() {
    const visibilityHelperTxtElm = document.querySelector('#visibility_helper_text');
    const isRepoPrivate = document.querySelector<HTMLInputElement>('input[name=private]').checked;
    const isRequiredSignInView = visibilityHelperTxtElm.getAttribute('data-sign-in-view') === 'true';
    const uidValInput = document.querySelector<HTMLInputElement>('#uid').value;
    const isOrgPrivate = document.querySelector(`.truncated-item-container[data-value="${uidValInput}"]`)?.getAttribute('data-privacy') === 'true';
    const orgName = document.querySelector('#repo_owner_dropdown .truncated-item-name').textContent;

    let visibilityMessage = '';

    if (isOrg() && isRepoPrivate) {
      visibilityMessage = `This repository will be visible to ${orgName} members with read permissions.`;
    } else if (isOrg() && !isRepoPrivate && isOrgPrivate) {
      visibilityMessage = `This repository will be visible to any members of ${orgName}.`;
    } else if (isOrg() && !isRepoPrivate && !isOrgPrivate && isRequiredSignInView) {
      visibilityMessage = 'This repository will be visible to any signed-in user.';
    } else if (isOrg() && !isRepoPrivate && !isOrgPrivate && !isRequiredSignInView) {
      visibilityMessage = 'This repository will be visible to anyone.';
    } else if (!isOrg() && isRepoPrivate) {
      visibilityMessage = 'This repository will be visible only to you and any users you add later as collaborators.';
    } else if (!isOrg() && !isRepoPrivate && isRequiredSignInView) {
      visibilityMessage = 'This repository will be visible to any signed-in user.';
    } else if (!isOrg() && !isRepoPrivate && !isRequiredSignInView) {
      visibilityMessage = 'This repository will be visible to anyone.';
    }

    visibilityHelperTxtElm.textContent = visibilityMessage;
  };

  privateInputElm.addEventListener('change', () => {
    handleOwnerText();
    handleVisibilityText();
  });

  uidInputElm.addEventListener('change', () => {
    handleOwnerText();
    handleVisibilityText();
  });

  // keep ecadtools and gitignores dropdowns in sync
  const ecadTools = $('#ecadtools-dropdown');
  const gitIgnores = $('#gitignores-dropdown');
  if (ecadTools.length && gitIgnores.length) {
    ecadTools.dropdown({
      onAdd: (added: string) => {
        const existingGitIgnores: string[] = gitIgnores.dropdown('get values');
        if (!existingGitIgnores.includes(added)) {
          setTimeout(() => {
            gitIgnores.dropdown('set selected', added); // "set" is actually add
          }, 0);
        }
      },
      onRemove: (removed: string) => {
        const existingGitIgnores: string[] = gitIgnores.dropdown('get values');
        if (existingGitIgnores.includes(removed)) {
          setTimeout(() => {
            gitIgnores.dropdown('remove selected', removed);
          }, 0);
        }
      },
    });

    gitIgnores.dropdown({
      onAdd: (added: string) => {
        const existingEcadTools: string[] = ecadTools.dropdown('get values');
        if (!existingEcadTools.includes(added)) {
          setTimeout(() => {
            ecadTools.dropdown('set selected', added); // "set" is actually add
          }, 0);
        }
      },
      onRemove: (removed: string) => {
        const existingEcadTools: string[] = ecadTools.dropdown('get values');
        if (existingEcadTools.includes(removed)) {
          setTimeout(() => {
            ecadTools.dropdown('remove selected', removed);
          }, 0);
        }
      },
    });
  }

  $('.ui.form').on('submit', (event) => {
    const ownerSelected = document.querySelector<HTMLInputElement>('#repo_owner_dropdown input')?.value.length > 0;
    if (!ownerSelected) {
      event.preventDefault();

      // display error message
      $('#owner_message').removeClass('tw:hidden');
    }
  });

  // run initially because the form saves the last value submitted for the visibility checkbox
  handleVisibilityText();
  handleOwnerText();
}
